import { MultiAutocomplete, type MultiAutocompleteOption } from '@components';
import { Box, Typography } from '@mui/material';
import type { FC, ReactElement } from 'react';

import { TABLE_FILTER_VISIBLE_VALUES } from '@web/constants/app';
import { getMaxVisibleItems } from '@web/helpers/app';

import type { SelectorOption } from '../Selector/Selector';

type Props = {
  label: string;
  options: SelectorOption[];
  selectedIDs: string[];
  onChange: (selectedIDs: string[]) => void;
  disabled?: boolean;
};

export const MultiSelectFilter: FC<Props> = ({
  label,
  options,
  selectedIDs,
  onChange,
  disabled,
}) => {
  const autocompleteOptions = options.map((opt): MultiAutocompleteOption<string> => ({
    value: opt.id,
    label: opt.name,
    sublabels: opt.subLabel === undefined ? undefined : [opt.subLabel],
  }));
  const selectedOptions = autocompleteOptions.filter((opt) => selectedIDs.includes(opt.value));

  return (
    <Box
      sx={(theme) => ({
        minWidth: '15rem',
        maxWidth: '25rem',
        '& .MuiAutocomplete-inputRoot': { flexWrap: 'nowrap' },
        [theme.breakpoints.down('lg')]: {
          maxWidth: '100%',
          flex: 1,
        },
      })}
    >
      <MultiAutocomplete
        withCheckbox
        disabled={disabled}
        label={label}
        options={autocompleteOptions}
        value={selectedOptions}
        onChange={(selected): void => onChange(selected.map((opt) => opt.value))}
        renderValue={(selected): ReactElement => {
          const { displayItems, extraCount } = getMaxVisibleItems(
            selected.map((opt) => opt.label),
            TABLE_FILTER_VISIBLE_VALUES,
          );
          return (
            <Typography noWrap sx={{ minWidth: 0 }}>
              {`${displayItems.join(', ')}${extraCount > 0 ? ` +${extraCount}` : ''}`}
            </Typography>
          );
        }}
      />
    </Box>
  );
};
